import { render, staticRenderFns } from "./RuleDetails.vue?vue&type=template&id=347cb077"
import script from "./RuleDetails.vue?vue&type=script&lang=ts"
export * from "./RuleDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports